<template>
    <activate-config/>
</template>

<script>
    import ActivateConfig from "./ActivateConfig";

    export default {
        name: "Activate",
        head(){
            return {
                title: "Activate"
            }
        },
        components: {ActivateConfig},
    }
</script>

